export const COMMANDS = {
    CLEAN: 'clean',
    CENTERING: 'centering',
    INFLATE: 'inflate',
    DECIMATE: 'decimate',
    WALLS: 'walls',
    SOLIDIFY: 'solidify'
}